export default __webpack_public_path__ + "static/media/loading-img.a252ca69.svg";